export default "__VITE_ASSET__CkciH5ze__"